/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBacktomap = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 7.953C6.028 4.953 8.664 2 11.991 2 15.315 2 17.974 4.95 18 7.955l.001.021c.003.045.005.103.006.174 0 .141-.008.333-.036.573-.056.481-.195 1.152-.51 1.995-.632 1.687-1.966 4.049-4.745 6.971l-.725.762-.724-.762c-2.78-2.923-4.11-5.285-4.737-6.974-.314-.843-.45-1.514-.504-1.996a4.762 4.762 0 0 1-.033-.574A2.954 2.954 0 0 1 6 7.953zM11.991 4C9.821 4 8 6.017 8 8v.063l-.006.046-.001.053c0 .061.002.173.02.332.036.317.133.83.392 1.525.466 1.255 1.462 3.12 3.586 5.505 2.126-2.386 3.126-4.251 3.596-5.507.26-.696.36-1.21.398-1.527a2.798 2.798 0 0 0 .02-.386L16 8.06V8c0-1.979-1.834-4-4.009-4zM12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm-4.009 8H8.61v2H6.227l-1 2h13.764l-1-2H15.61v-2h3.618l3 6H1.991z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBacktomap as Backtomap };
